var animatedmarquee;
var animationtimeout;
var marqueetext;
var speed;
var initialwidth;


function setmarqueewidth() {
$('.marquee-text').each(function( index ) {
    var marqueewidth = $(this).width();
    var initialwidth = $(this).find('.initialmarquee').width();
    $(this).attr('data-width', `${marqueewidth}`);
    $(this).attr('data-initial-width', `${initialwidth}`);
});
}

$(function () {
setmarqueewidth();
});

$('.capabilityitem:not(.project-img-video)').click(function(){
    $(this).toggleClass('capability-open');
});


  $(".capabilityitem").mouseenter(function(){
    clearTimeout(animationtimeout)
    marqueetext = $(this).find('.desktop-marquee').get(0);
    initialwidth = $(marqueetext).attr('data-initial-width');
    animatemarquee(marqueetext,initialwidth);
  })
  

  $(".capabilityitem").mouseleave(function(){
    marqueetext = $(this).find('.desktop-marquee').get(0);
    cancelmarquee();
  })
  

function animatemarquee(el,initialwidth) {
 
  speed = ((initialwidth / 25000) * 25000) * 10;

  animatedmarquee = el.animate([
    { transform: 'translateX(0)' }, 
    { transform: `translateX(-${initialwidth}px)` }
  ], {
    duration: speed,
    iterations: 2000
  }) 
}

function cancelmarquee() {
    animationtimeout = setTimeout(() => {
        animatedmarquee.cancel();
        animatedmarquee.finish();
      }, "500");
}


$(window).resize(function() {
  setmarqueewidth();
});

